import fetchData from '@/lib/fetchData';

const ROOT_API = process.env.VUE_APP_ROOT_API;
const old_GET_TREE_LIST = ROOT_API + 'inspection/recount/get_tree_list.php';
const GET_SPECIES_LIST = ROOT_API + 'inspection/recount/get_species_list.php';
const GET_DAMAGE_REASON_LIST = ROOT_API + 'inspection/recount/get_damage_reason_list.php';
const GET_DAMAGE_SYMPTOM_LIST = ROOT_API + 'inspection/recount/get_damage_symptom_list.php';

export default {
  state: {
    treeList: {},
    treeListLoading: false,

    speciesList: [],

    damageReasonList: [],
    damageSymptomList: [],
  },

  mutations: {
    setTreeListOfPlot(state, payload) { state.treeList[payload.plot_id] = payload.treeList; },
    clearTreeList(state) { state.treeList = {}; },
    setTreeListLoading(state, loading) { state.treeListLoading = loading; },

    setSpeciesList(state, speciesList) { state.speciesList = speciesList; },

    setDamageReasonList(state, reasonList) { state.damageReasonList = reasonList },
    setDamageSymptomList(state, symptomList) { state.damageSymptomList = symptomList },
    clearDamageReasonList(state) { state.damageReasonList = []; },
    clearDamageSymptomList(state) { state.damageSymptomList = []; }
  },

  actions: {
    old_fetchTreeList({ rootState, commit }) {
      const plotList = rootState.selectedLpo.recount.plotList;
      if (!plotList.length) {
        return;
      }

      commit('clearTreeList');
      commit('setTreeListLoading', true);

      const promises = plotList.map(plot => {
        const form = new FormData();
        form.append('plot_id', plot.id);
        return fetchData(GET_TREE_LIST, form).then(res => {
          const payload = {
            plot_id: plot.id,
            treeList: res
          };
          commit('setTreeListOfPlot', payload);
        });
      });

      return Promise.all(promises).then(res => {
        commit('setTreeListLoading', false);
      })

    },

    fetchSpeciesList({ rootState, commit }) {
			const lpo_id = rootState.selectedLpo.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_SPECIES_LIST, form).then(res => {
				commit('setSpeciesList', res);
			})
			.catch(err => console.log(err));
		},

    fetchDamageReasonList({ commit }, payload) {
      console.log('fetch reason list');
      const { addingTree, reasonFirstMode, symptomIdListStr } = payload;

      const species_id = addingTree?.species?.id;
      const reason_first_mode = reasonFirstMode;
      const symptom_list = symptomIdListStr;

      if (!species_id) {
        throw new Error('NO_SPECIES_ID');
      }

			const form = new FormData();
			form.append('species_id', species_id);
      form.append('reason_first_mode', reason_first_mode);
      form.append('symptom_list', symptom_list);

			return fetchData(GET_DAMAGE_REASON_LIST, form).then(res => {
        commit('setDamageReasonList', res);
			});
    },

    fetchDamageSymptomList({commit}, payload) {
      const { reasonFirstMode, addingTree, selectedReason, symptomIdListStr } = payload;

      const reason_first_mode = reasonFirstMode;
      const species_id = addingTree?.species?.id;
      const state_cat_id = addingTree?.state_cat?.id;
      const reason_id = selectedReason?.id || null;
      const symptom_list = symptomIdListStr;
			
      if (!state_cat_id) {
        throw new Error('NO_STATE_CAT_ID');
      }
      if (reasonFirstMode && !reason_id) {
        throw new Error('NO_REASON_ID');
      }

			const form = new FormData();
      form.append('reason_first_mode', reason_first_mode);
      form.append('species_id', species_id);
			form.append('state_cat_id', state_cat_id);
			form.append('reason_id', reason_id);
      form.append('symptom_list', symptom_list);
			
			return fetchData(GET_DAMAGE_SYMPTOM_LIST, form).then(res => {
        commit('setDamageSymptomList', res);
			});
    }
  }
};